// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"e184da72a5613c8f7227","777":"191f48a1c35f480d938b","939":"8e2a6bb6d481828e86fe"}[chunkId] + ".js";
};